<template>
  <v-row
    align="stretch"
    justify="start"
  >
    <v-col
      cols="12"
    >
      <price-table
        context="price-groups"
        :pricegroup="pricegroup"
        @update="update"
      />
    </v-col>
    <v-col cols="12">
      <price-sheet
        :last-updated="lastUpdate"
        context="price-groups"
      />
    </v-col>
  </v-row>
</template>
<script>
  import Auth from '@/mixins/Auth'

  export default {
    mixins: [Auth],
    props: {
      pricegroup: {
        type: Object,
        default: () => ({}),
      },
    },
    data () {
      return {
        lastUpdate: Date.now(),
      }
    },
    methods: {
      update: function () {
        this.lastUpdate = Date.now()
      },
    },
  }
</script>
